import { getLeadOverview } from '@/utils/leadConsumption';

export function calculateRemainLeads(userInfo) {
    const overview = getLeadOverview({ tarifs: userInfo?.tarifs, bonuses: userInfo?.bonuses });

    if (overview.isUnlimited) {
        return {
            status: 'unlimited',
            count: { type: 'infinity' },
        };
    }

    return {
        status: 'limited',
        count: overview.totalRemaining,
    };
}
